(() => {
  const storageKey = 'ti-selected-vehicle-v1';
  const strings = window.tiStorefrontStrings?.contact || {};
  const fill = (template, token, value) => (template || '').replace(token, value);

  const readVehicle = () => {
    try {
      const vehicle = JSON.parse(localStorage.getItem(storageKey) || 'null');
      if (vehicle?.year && vehicle?.make && vehicle?.model) return vehicle;
    } catch (_) {
      // Ignore corrupt or unavailable browser storage.
    }
    return null;
  };

  const populateVehicleContext = () => {
    const vehicle = readVehicle();
    const params = new URLSearchParams(window.location.search);
    const queryYear = params.get('year');
    const queryVehicle = params.get('vehicle');
    const selectedYear = queryYear || vehicle?.year;
    const selectedVehicle = queryVehicle || (vehicle ? `${vehicle.make} ${vehicle.model}` : '');
    if (!selectedYear || !selectedVehicle) return;

    const label = `${selectedYear} ${selectedVehicle}`;
    document.querySelectorAll('[data-ti-selected-vehicle]').forEach((element) => {
      element.textContent = fill(strings.selectedVehicle, '__VEHICLE__', label);
      element.hidden = false;
    });

    const yearField = document.querySelector('#ContactForm-vehicle-year');
    const vehicleField = document.querySelector('#ContactForm-vehicle');
    if (yearField && !yearField.value) yearField.value = selectedYear;
    if (vehicleField && !vehicleField.value) vehicleField.value = selectedVehicle;

    const customSubjectField = document.querySelector('#TiContactForm-subject');
    const customBodyField = document.querySelector('#TiContactForm-body');
    if (customSubjectField && !customSubjectField.value && strings.fitmentSubject) {
      customSubjectField.value = fill(strings.fitmentSubject, '__VEHICLE__', label);
    }
    if (customBodyField && !customBodyField.value && strings.fitmentBody) {
      customBodyField.value = fill(strings.fitmentBody, '__VEHICLE__', label);
    }
  };

  const populateContactQuery = () => {
    const params = new URLSearchParams(window.location.search);
    const topic = params.get('topic');
    const topicField = document.querySelector('#ContactForm-topic');
    const topicOption = topicField && [...topicField.options].find((option) => option.dataset.topic === topic);
    if (topicOption) topicField.value = topicOption.value;

    const productField = document.querySelector('#ContactForm-product');
    if (productField && !productField.value) {
      const product = params.get('product');
      const sku = params.get('sku');
      const skuLabel = sku && fill(strings.skuLabel, '__SKU__', sku);
      productField.value = [product, skuLabel].filter(Boolean).join(' — ');
    }
  };

  const start = () => {
    populateVehicleContext();
    populateContactQuery();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
